import _ from "lodash";
window._ = _;

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Swal from "sweetalert2";
window.Swal = Swal;

// Import Bootstrap JavaScript for dropdowns, modals, etc.
// Use the version that comes with AdminLTE to avoid conflicts
import "admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js";

// AdminLTE includes Bootstrap 4, so we don't need to import Bootstrap 5
// This prevents version conflicts between Bootstrap 4 (AdminLTE) and Bootstrap 5

// DataTables will be initialized after jQuery is loaded
// We'll handle this in the main app.js file

// Import and expose unified SweetAlert2 service
import swalService from "./utils/swalService";
window.SwalService = swalService;

// Keep SwalWithBootstrap for backward compatibility (deprecated - use SwalService instead)
window.SwalWithBootstrap = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary mx-3",
    cancelButton: "btn btn-danger mx-3",
  },
  buttonsStyling: false,
});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
